module.exports = "static/assets/cb3ac3b4a8540f50937a86af7eb4663c.woff2";